import { useEffect } from "react";
import { initGA } from "@/utils/analytics";
import { APP_VERSION } from "@/utils/cacheControl";
import { useAuth } from "@/hooks/auth";
import { setSentryUser } from "@/integrations/sentry/client";
import NotificationInitializer from "@/components/NotificationInitializer";
import { useSessionMonitor } from "@/hooks/useSessionMonitor";
import {
  addDebugFunctions,
  removeDebugFunctions,
} from "@/utils/sessionTestUtils";

// Configure version in a way that changes on every build
const APP_BUILD_ID = APP_VERSION;

const AppInitializer: React.FC = () => {
  const { user } = useAuth();

  // Initialize session monitoring
  useSessionMonitor({
    checkInterval: 60000, // Check every minute
    warningThreshold: 5 * 60 * 1000, // Warn 5 minutes before expiry
    autoRefreshThreshold: 10 * 60 * 1000, // Auto-refresh 10 minutes before expiry
    enableWarnings: true,
    enableAutoRefresh: true,
  });

  useEffect(() => {
    // Initialize Google Analytics
    initGA();
    try {
      let sessionId = localStorage.getItem("userSessionId");

      if (!sessionId) {
        sessionId = crypto.randomUUID();
        localStorage.setItem("userSessionId", user?.id || sessionId);
      }
    } catch (error) {
      // Fallback if localStorage is not available (e.g., private browsing)
      console.error("Error getting session ID:", error);
    }
    // Note: Document titles are supplied by Next.js route metadata
    // This allows for dynamic page titles without conflicts
  }, []);

  // Set Sentry user context when user changes
  useEffect(() => {
    setSentryUser(user);
  }, [user]);

  return (
    <>
      <NotificationInitializer />
    </>
  );
};

export default AppInitializer;
